import type {
  TLedgerBinding,
  TLedgerConfidence,
  TLedgerProvenance,
  TLedgerRole,
  TLedgerTreatment
} from "@/zapi-frontend/shared/types/modelLedger";
import type { TLedgerSourceBucket } from "./ledgerFormat";

export const ROLE_LABEL_KEY = {
  objective: "modelLedger.roleObjective",
  decision: "modelLedger.roleDecision",
  constraint: "modelLedger.roleConstraint",
  assumption: "modelLedger.roleAssumption",
  parameter: "modelLedger.roleParameter",
  intermediate: "modelLedger.roleIntermediate",
  output: "modelLedger.roleOutput"
} as const satisfies Record<TLedgerRole, string>;

export const PROVENANCE_LABEL_KEY = {
  frame: "modelLedger.provenanceFrame",
  client: "modelLedger.provenanceClient",
  research: "modelLedger.provenanceResearch",
  benchmark: "modelLedger.provenanceBenchmark",
  expert: "modelLedger.provenanceExpert",
  feed: "modelLedger.provenanceFeed",
  computed: "modelLedger.provenanceComputed",
  engine: "modelLedger.provenanceEngine"
} as const satisfies Record<TLedgerProvenance, string>;

export const CONFIDENCE_LABEL_KEY = {
  validated: "modelLedger.confidenceValidated",
  estimated: "modelLedger.confidenceEstimated"
} as const satisfies Record<TLedgerConfidence, string>;

export const BINDING_LABEL_KEY = {
  hard: "modelLedger.bindingHard",
  soft: "modelLedger.bindingSoft"
} as const satisfies Record<TLedgerBinding, string>;

export const TREATMENT_LABEL_KEY = {
  held: "modelLedger.treatmentHeld",
  swept: "modelLedger.treatmentSwept",
  solved: "modelLedger.treatmentSolved",
  tracked: "modelLedger.treatmentTracked"
} as const satisfies Record<TLedgerTreatment, string>;

export const SOURCE_LABEL_KEY = {
  calculated: "modelLedger.sourceCalculated",
  brief: "modelLedger.sourceBrief",
  document: "modelLedger.sourceDocument",
  web: "modelLedger.sourceWeb",
  assumption: "modelLedger.sourceAssumption",
  other: "modelLedger.sourceOther"
} as const satisfies Record<TLedgerSourceBucket, string>;
